
import { Voni } from '../client';

export interface Lead {
  id: number;
  project_id: number;
  conversation_id?: number;
  email?: string;
  name?: string;
  phone?: string;
  data?: Record<string, unknown>;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface LeadUpdateInput {
  email?: string;
  name?: string;
  phone?: string;
  data?: Record<string, unknown>;
  status?: string;
}

export interface LeadListParams {
  skip?: number;
  limit?: number;
  [key: string]: unknown;
}

export class LeadResource {
  constructor(private client: Voni) {}

  async list(projectId: number, params?: LeadListParams): Promise<Lead[]> {
    return this.client.request<Lead[]>('GET', `/projects/${projectId}/leads`, params);
  }

  async get(projectId: number, leadId: number): Promise<Lead> {
    return this.client.request<Lead>('GET', `/projects/${projectId}/leads/${leadId}`);
  }

  async update(projectId: number, leadId: number, updates: LeadUpdateInput): Promise<Lead> {
    return this.client.request<Lead>('PUT', `/projects/${projectId}/leads/${leadId}`, undefined, updates);
  }

  async delete(projectId: number, leadId: number): Promise<boolean> {
    await this.client.request('DELETE', `/projects/${projectId}/leads/${leadId}`);
    return true;
  }
}
